import React, { Component, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";

export const useMountEffect = (fun) => useEffect(fun, []);
const utilizeFocus = () => {
    const ref = React.createRef()
    const setFocus = () => { ref.current && ref.current.focus() }
    return { setFocus, ref }
}

const divider = {
    width: "100%"
}

export default class NewComentarioContent extends Component {
    constructor(props) {
        super(props)
        this.input1Focus = utilizeFocus()
        this.state = { editor: null };
    }

    state = {
        card: ''
    }

    handleChange = event => {
        this.setState({ resposta: event });
    };

    _responder = (ev) => {
        if (this.state.resposta && this.state.resposta.length > 0) {
            this.props._setComentario(this.state.resposta);
            this.inputTitle.value = "";
            this.setState({ resposta: '' });
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.props.setFocus ?
                    this.setFocus()
                    : null
                }
                <div className="gb-divider"><div className="line" style={divider}></div></div>
                <div className="gb-form-title" style={{ marginBottom: 12 }}>
                    <i className="fas fa-comment-dots mr-1"></i> Adicionar Comentário
                </div>
                {/* <div className="gb-card-body"> */}
                <div>
                    {this.props.idComent ? (
                        <div className="alert alert-warning" >
                            Em resposta á: {this.props.idComent.desc}
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close"
                                onClick={() => { this.props._clearIdComent() }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    ) : null}
                    {this.props.card === "historico" || this.props.card === "comentario" ? (
                        <React.Fragment>
                            <div style={{ padding: '10px' }}>
                                <img
                                    src={
                                        this.props.user.avatarURL
                                            ? this.props.user.avatarURL
                                            : "https://firebasestorage.googleapis.com/v0/b/globalbrain-ba498.appspot.com/o/images%2Fno-user.jpg?alt=media&token=44616cc9-46e2-40ea-906f-28e46f58fb68"
                                    }
                                    style={{
                                        width: '32px',
                                        display: 'inline-block',
                                        marginRight: '13px',
                                    }}
                                    alt="Imagem do Profissional"
                                    className="rounded-circle img-fluid"
                                />
                                <div style={{ display: 'inline' }}>
                                    {this.props.user.firstName}
                                </div>
                            </div>
                            {/* <textarea type="text"
                                className="form-control"
                                placeholder="Digite o seu comentário..."
                                onChange={e => this.handleChange(e)}
                                rows="5"
                                style={{
                                    display: 'inline-block',
                                    width: '100%',
                                }}
                                ref={el => this.inputTitle = el}
                            /> */}
                            <Editor
                                onEditorChange={e => this.handleChange(e)}
                                value={this.state.resposta}
                                apiKey="jl2uw5yob5e4avhldqg1sm0npw0zkdayoz2xj4wwgr2lj1ei"
                                init={{
                                    language: 'pt_BR',
                                    // plugins: "spellchecker",
                                    height: 280,
                                    placeholder: "Digite o seu comentário...",
                                    toolbar: "undo redo | fontselect fontsizeselect | bold italic underline forecolor backcolor | align lineheight checklist bullist numlist",
                                    browser_spellcheck: true,
                                }}
                                ref={el => this.inputTitle = el}
                            ></Editor>


                            <button
                                style={{ float: 'right', marginTop: '10px' }}
                                onClick={(ev) => { this._responder(); }}
                                type="button"
                                className="btn gb-button"
                            >
                                Comentar
                            </button>
                        </React.Fragment>
                    ) : null
                    }
                </div>
            </React.Fragment>
        )
    }
}